import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/vehicle-inspection/',
    name: 'Vehicle Inspection',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['m1e-vehicle-inspection:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "vehicle-inspection" */ '@/router/views/vehicle-inspection'),
  },

  {
    path: '/vehicle-inspection/:id',
    name: 'Vehicle Inspection Form',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['m1e-vehicle-inspection:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "vehicle-inspection" */ '@/router/views/vehicle-inspection/form'),
  },

]
